module.exports = __webpack_public_path__ + "public/images/captcha-star.9e33b62f7abdfa7814e81b21d922b503.svg";